if(!customElements.get('cart-recommended-product-form')){
    class CartRecommendedProductForm extends HTMLElement {
        constructor(){
            super();
        }

        connectedCallback(){
            this.openVariantPopup = this.dataset.variantPopup == 'true';
            this.product = this.closest('cart-recommended-product');
            this.productFormId = this.dataset.id;

            this.variantPopup = document.querySelector('variant-popup');

            this.form = this.querySelector("form");
     
            this.buttonCart = this.querySelector('.button-cart');
            if(this.buttonCart){
                this.buttonCart.addEventListener("click", this.addToCart.bind(this));
                this.buttonCart.addEventListener("keydown", e => {
                    if(e.key === 'Enter') this.addToCart();
                });
            }
        }

        addToCart(){
            if(this.buttonCart.classList.contains('disabled')) return;
            if(this.openVariantPopup){
                this.onOpenVariantPopup();
                return;
            }

            this.onSubmitToCart();
        }

        get selectedOptionValues() {
            return Array.from(this.product.querySelectorAll('fieldset input:checked')).map(
                ({ dataset }) => dataset.optionValueId
            );
        }

        onOpenVariantPopup(){
            if(!this.variantPopup) return;

            const data = {
                productUrl: `${this.dataset.productUrl}`,
                productId: this.querySelector('input[name="id"]').value,
                selectedOptionValues: this.selectedOptionValues
            }

            if(!data.productUrl) return;
            if(!data.productId) return;

            PubSub.publish(PubSub.events.onVariantPopup, {
                data: data
            })
        }

        onSubmitToCart(){
            // handle error message
            this.handleErrorMessage();

            this.buttonCart.classList.add('disabled');
            this.buttonCart.classList.add('loading');
            this.product?.querySelector(".badge--sold-out")?.remove();

            const formData = new FormData(this.form);

            // config
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            config.body = formData;

             fetch(`${routes.cart_add_url}`, config)
            .then(res => res.json())
            .then(res => {
                if(res.status) {
                    this.handleErrorMessage(res.description);

                    // sold out
                    if(this.buttonCart){
                        this.buttonCart.classList.remove('loading');
                        this.buttonCart.classList.remove('inner-group');
                    }

                    const soldoutBadge = document.createElement('span');
                    soldoutBadge.innerHTML = window.cart.badge.sold_out;
                    soldoutBadge.classList.add('badge', 'badge--sold-out', 'my-3', 'max-w-max');

                    if(this.product){
                        this.product.querySelectorAll(".badge").forEach(item => item.remove());

                        if(this.product.querySelector(".price")){
                            this.product.querySelector(".price").append(soldoutBadge);

                            this.product.querySelector('.price').classList.add('price--sold-out');
                            this.product.querySelector('.price').classList.remove('price--on-sale');
                            this.product.querySelector('.price').classList.remove('price--no-compare');
                            this.product.querySelector('.price').classList.remove('volumn-pricing--sale-badge');
                        }
                    }

                    this.error = true;
                    return;
                }

                PubSub.publish(PubSub.events.cartUpdate, {
                    source: 'cart-reload'
                });
                this.error = false;
                this.updateCartSize();
            }).catch(e => {
                console.error(e);
            }).finally(() => {
                this.buttonCart.classList.remove('disabled');
                this.buttonCart.classList.remove('loading');
            });
        }

        handleErrorMessage(message = ""){
            const errorWrapper = this.product.querySelector(".error");
            if(!errorWrapper) return;

            errorWrapper.querySelector('small').innerText = `${message}`;
        }

        updateCartSize(){
            const cartIconURL = `/?section_id=header-cart-icon`;
            fetch(cartIconURL)
            .then(res => {
                if (!res.ok) {
                    var error = new Error(res.status);
                    throw error;
                }
                return res.text();
            }).then(text => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-header-cart-icon').innerHTML;

                const header = document.querySelector('custom-header');
                const cartSizeIcons = header?.querySelectorAll('.cart-item-size');
                if(cartSizeIcons.length > 0){
                    cartSizeIcons.forEach(item => {
                        item.innerText = `${resultsMarkup.trim()}`;
                        item.setAttribute('aria-hidden', 'false');
                    });
                }
            }).catch(e => {
                console.error(e);
            });
        }
    }

    customElements.define('cart-recommended-product-form', CartRecommendedProductForm);
}